import React from 'react';
import SectionSummary from '../ui/SectionSummary';

const MixedIncomeSeparationGuide = () => {
  return (
    <div className="bg-slate-900/60 p-8 rounded-3xl border border-white/5">
      <h2 className="text-2xl font-bold text-white mb-4">Are Mixed Bank Feeds a Compliance Risk?</h2>
      <div className="prose prose-invert max-w-none text-slate-300 mb-6">
        <p>
          Under <strong>Making Tax Digital 2026</strong> regulations (see BIM42100), digital linking requires a clear audit trail.
          When <strong>HMRC</strong> audits standard retail bank accounts, picking out single <strong>MTD ITSA</strong> allowable expenses from thousands of personal grocery and lifestyle transactions becomes a massive compliance risk. Sole traders must strictly unmix personal expenses from their business allowable expenses.
        </p>
        <div className="h-6" />
        <p>
          You can mitigate this risk via <strong>WhatsApp</strong>. Even if you use a personal card or a mixed bank account, snapping the specific business receipt and sending it via WhatsApp to Zap Expenses stores that receipt and extracts fields for review. You still create the MTD digital record in compatible software.
        </p>
      </div>

      <SectionSummary
        takeaway="Sole traders must unmix personal expenses from business allowable expenses when creating digital records. Logging each business receipt at source makes that split easier to evidence. It does not by itself complete MTD filing."
        hmrcRef={<a href="https://www.gov.uk/hmrc-internal-manuals/business-income-manual/bim42110" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-300 underline">Gov.uk: How to Establish Expense Purpose (BIM42110)</a>}
      />
    </div>
  );
};

export default MixedIncomeSeparationGuide;
